<section class="app-cit-rul">
  <div class="app-cit-rul__rul">
    <div class="app-cit-rul__rul__vio">
      <h3 class="app-cit-rul__rul__vio__tit">ZASADY WYJAZDU</h3>
      <p class="text-center">
        Aby uzyskać szczegółowe informacje na temat wydarzenia, skontaktuj się z Twoim Business Partnerem, który chętnie
        odpowie na wszystkie pytania i pomoże w organizacji wyjazdu.
      </p>
      <!-- <p>Płatność 3k pln w gotówce</p> -->
      <!-- <p>Zamówienie bez rabatu na odpowiednią kwotę</p>
      <p>Umowa do podpisania</p>
      <p>
        Po podpisaniu umowy wyłączamy rabat do momentu zrealizowania założeń z<br class="d-none d-md-inline" />
        umowy
      </p> -->
    </div>

    <div class="app-cit-rul__rul__pho">
      @for (p of photos(); track $index) {
        <img [src]="p" alt="Zasady wyjazdu" />
      }
    </div>
  </div>

  <div class="app-cit-rul__con">
    <span class="app-cit-rul__con__que">Masz dodatkowe pytania?</span>
    <span class="app-cit-rul__con__con"
      >Skontaktuj się z nami klikając <a [routerLink]="['/', wwwRouteSlug.CONTACT]">tutaj</a></span
    >
  </div>
</section>
